"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.step.progress': '步骤 {current} / {total}',
};
